import {
  Typography,
  Grid2, 
  Box, 
} from '@mui/material';
import { Link } from "react-router-dom";
import { } from "@mui/material";
const Footer = ({}) => {
  return (
    <Box sx={{ backgroundColor: 'rgba(40, 165, 52, 0.5)', color: "white", padding: 2 }}>
    <Typography variant="body1" align="center">
      &copy; 2024 Rōpū Whakatau | All Rights Reserved
    </Typography>
    <Grid2 container justifyContent="center" sx={{ marginTop: 1 }}>
      <Grid2 item sx={{ marginX: 2 }}>
        <Link style={{ color: "white" }} to="/privacy">Privacy Policy</Link>
      </Grid2>
      <Grid2 item sx={{ marginX: 2 }}>
        <Link style={{ color: "white" }}>Terms of Service</Link>
      </Grid2>
    </Grid2>
  </Box>
  );
};

export default Footer;
